import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { GameCssStyles } from "../../GameManagement/GameCssStyles";

export const MetadataSelectField = ({ label, value, onChange, options }) => {
    console.log("value: ",value)
    console.log("options: ",options)
    return (<FormControl fullWidth>
        <InputLabel sx={GameCssStyles.inputLabelStyle_sx}>{label}</InputLabel>
        <Select
            value={value || ''}
            onChange={(e) => onChange(e.target.value)}
            label={label}
            sx={GameCssStyles.formFiledStyle_sx2}
        >
            <MenuItem value="" disabled>{`Select ${label}`}</MenuItem>
            {options?.map((item, idx) => (
                <MenuItem key={idx} value={item?.value || item} sx={GameCssStyles.menuItemStyle_sx}>
                    {item?.label}
                </MenuItem>
            ))}
        </Select>
    </FormControl>)
};